import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppContext } from 'src/components/app-context';
import { NavigationSliceView } from 'src/areas/product-collection/components/navigation/navigation-component';
import { trackKWLPCategoryClick } from '../tracking';
import type { FacetLink } from 'src/areas/product-collection/components/navigation/types';
import type { KeywordLandingPageQuery } from '../../../types';

interface Props {
  categories: KeywordLandingPageQuery['keywordLandingPage']['categories']['nodes'];
}

export const CategoryResults: React.FC<Props> = ({ categories }) => {
  const { linkTo } = useAppContext();
  const history = useHistory();

  const facetLinks: FacetLink[] = useMemo(
    () =>
      categories.map(category => {
        const { id, name: value, image: imageUrl } = category;

        const path = linkTo('category', category);

        return {
          id,
          value,
          path,
          imageUrl,
          indexable: true,
          selected: false,
        };
      }),
    [categories, linkTo]
  );

  return categories.length ? (
    <NavigationSliceView
      links={facetLinks}
      onClickPreventDefault
      onClick={link => {
        if (link.path) {
          history.push(link.path);
          trackKWLPCategoryClick(link.value, link.id);
        }
      }}
    />
  ) : null;
};
